import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { SearchCustomerParam } from 'src/app/Models/searchCustomer';
import { TransactionService } from '../../../Services/transaction.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { NotificationService } from 'src/app/Services/notification.service';
@Component({
  selector: 'app-searach-customer',
  templateUrl: './searach-customer.component.html',
  styleUrls: ['./searach-customer.component.css']
})
export class SearachCustomerComponent implements OnInit, AfterViewInit {  
  private utility: Utility
  public FormModel: SearchCustomerParam;
  public CustomerListHeader: String[] = ["saleCode", "companyName", "contact", "contactPreference", "saleRank"];
  dataSource = new MatTableDataSource<any>();
  public IsRental:boolean
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;  
  constructor(
    private _TransactionService: TransactionService
    , private intl: MatPaginatorIntl
    , private changeDectector: ChangeDetectorRef
    , private cookieService: CookieService
    , private router: Router
    , private route: ActivatedRoute
    , private _NotificationService:NotificationService
  ) {    
    this.utility = new Utility(this.cookieService);    
    this.FormModel = new SearchCustomerParam();
    this.sort = new MatSort();
    this.IsRental = false;
    this.paginator = new MatPaginator(this.intl, this.changeDectector);
    this.route.params.subscribe( (params) =>{
      if(params.IsRental != undefined && params.IsRental ==1){
        this.IsRental = true;
      }
    });

    let param: any = this.router.getCurrentNavigation()?.extras.state;
    if (param) {     
      if (param.Message){
        this._NotificationService.showSuccess(param.Message,"");
      }
    }

  }

  ngOnInit(): void {        
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }


  searchCustomer(searchCustomerParam: SearchCustomerParam) {
      if(this.IsRental){  //added by rahul yadav on 4/6/2021 in case of rental
        searchCustomerParam.isRental = true;
      }
      this._TransactionService.GetDealersFroSpraSeacrch(searchCustomerParam).subscribe((d: any) => {
        this.dataSource.data = d;
        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });
      if(d.length<=0){
         this._NotificationService.showError("No record found.","Search Result");
      }
    }, (error) => {                              //Error callback    
      this.utility.Error(error);
      this._NotificationService.showError();
    });


  }


  public doFilter = (event: any) => {
    this.dataSource.filter = event.target.value.trim().toLocaleLowerCase();
  }

  onContactClick(Company:any) {
    let page:string = "spra-request"
    if(this.IsRental){
      page = "spra-rental-request";
    }

    this.router.navigate([page], {
      state: {
        "RefId": Company.refNo,
        "CompanyId": Company.companyId,        
        "OfficeId":Company.officeId,
        "SaleType":Company.saleType,
        "SaleCode":Company.saleCode,
        "PartnerId":Company.partnerId
      }
    });
  }


}
